import { GET } from "../../helper/xbi4RestFunctions";
export const getIndEmployeePay = async (org_id:any,employee_id:any) => {
  const path = `/orgs/${org_id}/employee/${employee_id}/payments`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching org details >", err);
      return err;
    });
};